module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    directives: [{
      name: "loading",
      rawName: "v-loading",
      value: (_vm.isLoading),
      expression: "isLoading"
    }],
    staticClass: "m-l-50 m-t-30"
  }, [_c('common-config', {
    attrs: {
      "id": _vm.id,
      "form": _vm.form,
      "inputList": _vm.inputList,
      "isLimit": false
    }
  }, [_c('template', {
    slot: "self-config"
  }, [_c('el-form-item', {
    attrs: {
      "label": "可用变量表"
    }
  }, [_c('el-table', {
    staticStyle: {
      "width": "600px"
    },
    attrs: {
      "data": _vm.showWordFileList
    }
  }, [_c('el-table-column', {
    attrs: {
      "prop": "variableName",
      "label": "变量名"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "variable",
      "label": "变量"
    }
  })])]), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "模板上传"
    }
  }, [_c('div', {
    staticClass: "exportword-upload"
  }, [_c('el-upload', {
    ref: "fileupload",
    staticClass: "upload-demo",
    attrs: {
      "action": _vm.fileUrl,
      "accept": _vm.accept,
      "before-upload": _vm.beforeUpload,
      "on-success": _vm.successCb,
      "on-remove": _vm.removeCb,
      "file-list": _vm.fileList
    }
  }, [_c('el-button', {
    attrs: {
      "size": "small",
      "type": "primary"
    }
  }, [_vm._v(_vm._s(_vm.upload_name))]), _vm._v(" "), _c('div', {
    staticClass: "el-upload__tip",
    slot: "tip"
  }, [_vm._v("只支持上传.docx格式文档,且不超过5M")])]), _vm._v(" "), _c('a', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.fileList.length > 0),
      expression: "fileList.length>0"
    }],
    staticClass: "downloadBtn",
    attrs: {
      "href": _vm.form.downFile.url,
      "download": _vm.form.downFile.name
    }
  }, [_vm._v("下载文档")])])])])], true)])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-95eb41aa!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/Content/abstract/dealConfig/exportWord.vue
// module id = 1957
// module chunks = 2